import { logger } from '@zep/core-logger';
import { useOpenWindow, useViewport } from '@/hooks';
import { useIsInExternalPlatform } from '@/shared/externalPlatform';
import { cn } from '@/utils/tailwind.util';
import { PublicQuizTooltip } from './PublicQuizTooltip';
interface AuthorTagProps {
  authorName: string;
  isOfficial?: boolean;
  authorHashId: string;
  iconSize?: 'xs' | 'sm';
  className?: string;
}
export const AuthorTag = ({
  authorName,
  isOfficial = false,
  authorHashId,
  iconSize = 'sm',
  className
}: AuthorTagProps) => {
  const {
    isMobile
  } = useViewport();
  const openWindow = useOpenWindow();
  const isInExternalPlatform = useIsInExternalPlatform();
  const handleClick = (e: React.MouseEvent) => {
    if (isInExternalPlatform) return;
    e.preventDefault();
    e.stopPropagation();
    logger.track('click_user_profile');
    openWindow(`/profile/${authorHashId}`);
  };
  return <div className={cn('group/author inline-flex w-fit items-center gap-4xs', !isInExternalPlatform && 'cursor-pointer')} onClick={handleClick} data-sentry-component="AuthorTag" data-sentry-source-file="AuthorTag.tsx">
      <span className={cn('truncate text-center text-neutral text-body-md-medium', !isInExternalPlatform && 'group-hover/author:text-assistive', className)}>
        {authorName}
      </span>
      {isOfficial && !isInExternalPlatform && <PublicQuizTooltip triggerIconSize={iconSize} onClick={!isMobile ? handleClick : undefined} />}
    </div>;
};